/* unplugin-vue-components disabled */import script from "./UploadInfoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadInfoModal.vue?vue&type=script&setup=true&lang=ts"

import "./UploadInfoModal.vue?vue&type=style&index=0&id=038ca4c4&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-038ca4c4"]])

export default __exports__